import axios from 'axios'
import { castAttributesForCamelCase } from '../../modules/string_converter'
import { i18n } from '../../plugins/i18n'

export const companiesFoodMenus = {
  namespaced: true,
  state: {
    data: null,
    meta: null,
    loading: false,
    notAvailable: false
  },
  mutations: {
    apiConnect(state) {
      state.loading = true
      state.notAvailable = false
    },
    readFoodMenusSuccess(state, payload) {
      state.data = payload.data.map(obj => castAttributesForCamelCase(obj))
      state.meta = castAttributesForCamelCase(payload.meta)
      state.loading = false
    },
    apiFailure(state) {
      state.loading = false
    },
    apiNotAvailable(state) {
      state.notAvailable = true
    },
    deleteFoodMenuSuccess(state, id) {
      state.data = state.data.filter(v => v.id !== id)
      state.loading = false
    }
  },
  actions: {
    readFoodMenus({ commit, rootState }, query = null) {
      commit('apiConnect')
      return axios
        .get(`/api/companies/${rootState.route.params.company_uuid}/food_menus`, {params: query})
        .then(res => {
          commit('readFoodMenusSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          if(err.response.status === 422) {
            commit('apiNotAvailable')
          }
        })
    },
    deleteFoodMenu({ commit, rootState }, id) {
      commit('apiConnect')
      return axios
        .delete(`/api/companies/${rootState.route.params.company_uuid}/food_menus/${id}`)
        .then(() => {
          commit('deleteFoodMenuSuccess', id)
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.deleted', { value: i18n.t('models.foodMenu.modelName') }) }, { root: true })
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    }
  }
}
